import Swiper from 'swiper/bundle';
export default class Carousel {
  constructor(element) {
    this.element = element;
    this.options = {
      slidesPerView: 1,
      spaceBetween: 0,
      centeredSlides: true,

      pagination: {
        el: this.element.querySelector('.swiper-pagination'),
        clickable: true,
      },
      navigation: {
        nextEl: this.element.querySelector('.swiper-button-next'),
        prevEl: this.element.querySelector('.swiper-button-prev'),
      },
    };

    this.init();
  }
  setOption() {
    if ('split' in this.element.dataset) {
      this.options.breakpoints = {
        768: {
          slidesPerView: 1,
        },
      };
    }

    if ('autoplay' in this.element.dataset) {
      this.options.autoplay = {
        delay: 2000,
        pauseOnMouseEnter: false,
        disableOnInteraction: false,
      };
    }
    if ('loop' in this.element.dataset) {
      this.options.loop = true;
    }
    if ('slide' in this.element.dataset) {
      this.options.slidesPerView = parseFloat(this.element.dataset.slide, 10);
    }

    if ('news' in this.element.dataset) {
      this.options.slidesPerView = 1;
      this.options.spaceBetween = 30;
      this.options.breakpoints = {
        540: {
          slidesPerView: 1,
        },
        1000: {
          slidesPerView: 1,
        },
        1400: {
          slidesPerView: 1,
        },
      };
    }
  }
  init() {
    this.setOption();

    // Fond flou de chaque slide : la même image, reprise par le CSS via --img
    this.element.querySelectorAll('.imageslide').forEach((slide) => {
      const img = slide.querySelector('img');
      if (img) slide.style.setProperty('--img', `url("${img.src}")`);
    });

    // Légendes lues avant l'init de Swiper (en mode loop, Swiper duplique les slides)
    this.captions = [...this.element.querySelectorAll('.swiper-slide')].map(
      (slide) =>
        slide.querySelector('.mediasubtitle h4')?.textContent.trim() || '',
    );

    this.swiper = new Swiper(this.element, this.options);
    this.initCaption();
  }

  // Recopie la légende de la slide active sous les contrôles (pagination + flèches)
  initCaption() {
    if (!this.captions.some(Boolean)) return;

    this.caption = document.createElement('div');
    this.caption.className = 'mediasubtitle swiper-caption';
    this.caption.setAttribute('aria-live', 'polite');

    this.captionTitle = document.createElement('h4');
    this.captionTitle.textContent = this.captions[this.swiper.realIndex];
    this.caption.appendChild(this.captionTitle);

    this.element.appendChild(this.caption);
    this.element.classList.add('has-caption'); // le CSS masque alors les légendes dans les slides

    this.swiper.on('slideChange', () => this.updateCaption());
  }

  updateCaption() {
    clearTimeout(this.captionTimer);
    this.caption.classList.add('is-changing'); // fondu sortant
    this.captionTimer = setTimeout(() => {
      this.captionTitle.textContent = this.captions[this.swiper.realIndex];
      this.caption.classList.remove('is-changing'); // fondu entrant
    }, 150);
  }
}
